import * as React from 'react'
import className from 'classnames'
import Fade from 'react-reveal/Fade'
import PropTypes from 'prop-types'
import * as style from './section-component.module.scss'

const Section = ({
  newClass,
  newTitleClass,
  isLight,
  title,
  children,
  hideText,
}) => (
  <section
    className={className(style.section, newClass, isLight && style.light)}
  >
    <div className="container">
      {!hideText && (
        <Fade bottom>
          <h2 className={className(style.title, newTitleClass)}>{title}</h2>
        </Fade>
      )}
      <div className={style.content}>{children}</div>
    </div>
  </section>
)
Section.propTypes = {
  newClass: PropTypes.string,
  isLight: PropTypes.bool,
  hideText: PropTypes.bool,
  title: PropTypes.string,
  children: PropTypes.node,
}
Section.defaultProps = {
  newClass: '',
  isLight: false,
  hideText: false,
  title: '',
  children: null,
}
export default Section
